import { ChevronRight } from 'lucide-react';
import { FC } from 'react';

interface StepCardProps {
  number: number;
  title: string;
  description: string;
  image: string;
  delay: string;
}

const StepCard: FC<StepCardProps> = ({ number, title, description, image, delay }) => {
  return (
    <div className='relative'>
      <div
        className='bg-card border border-border rounded-lg overflow-hidden transition-smooth hover:shadow-md hover:border-primary/20 animate-fadeInUp'
        style={{ animationDelay: delay }}>
        <div className='h-40 bg-muted relative overflow-hidden'>
          <img
            src={image}
            alt={title}
            className='w-full h-full object-cover transition-smooth hover:scale-105'
          />
          <div className='absolute top-4 left-4 flex items-center justify-center w-8 h-8 rounded-full bg-primary text-primary-foreground font-bold text-sm'>
            {number}
          </div>
        </div>
        <div className='p-6'>
          <h3 className='text-xl font-semibold mb-2 text-card-foreground'>{title}</h3>
          <p className='text-muted-foreground'>{description}</p>
        </div>
      </div>
      {number < 3 && (
        <div className='hidden lg:flex absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-primary rounded-full items-center justify-center shadow-md transition-smooth'>
          <ChevronRight size={20} className='text-primary-foreground' />
        </div>
      )}
    </div>
  );
};

export default StepCard;
